import React, { useState, useEffect } from "react";
import LazyLoad from "react-lazyload";
import parallaximg from "./../../assets/img/about/about-last-sec-img.png";

import * as apiUrl from "../../apiUrl";

function AboutParallax({data}) { 

  return ( 
      <div className="about-parallax-sec">
        <img
          src={apiUrl.apiUrl + `/` + data.last_image}
          className="img-fluid"
          alt="Marquis Developers"
        />
      </div> 
  );
}

export default AboutParallax;
